import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-dados-historico',
  templateUrl: './consulta-dados-historico.component.html',
  styleUrls: ['./consulta-dados-historico.component.scss']
})
export class ConsultaDadosHistoricoComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {}

}
